<template>
    <app-layout>
        <template #header>
            <h2 class="text-xl font-semibold leading-tight text-iron-800">
                Kiosk - Create user
            </h2>
        </template>

        <div class="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
            <div class="bg-white px-4 py-5 shadow sm:rounded-lg sm:p-6">
                <div class="md:grid md:grid-cols-3 md:gap-6">
                    <div class="md:col-span-1">
                        <h3 class="text-lg font-medium leading-6 text-iron-900">
                            User credentials
                        </h3>
                        <p class="mt-1 text-sm text-iron-500">
                            User will be created with verified email.
                        </p>
                    </div>
                    <div class="mt-5 md:col-span-2 md:mt-0">
                        <div class="grid grid-cols-6 gap-6">
                            <div class="col-span-6 sm:col-span-6">
                                <label
                                    for="name"
                                    class="block text-sm font-medium text-iron-700"
                                    >Name</label
                                >
                                <input
                                    id="name"
                                    v-model="form.name"
                                    type="text"
                                    name="name"
                                    autocomplete="name"
                                    class="mt-1 block w-full rounded-md border-iron-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                                />
                                <div
                                    v-if="form.errors.name"
                                    class="mt-2 text-xs text-error-600"
                                >
                                    {{ form.errors.name }}
                                </div>
                            </div>

                            <div class="col-span-6 sm:col-span-6">
                                <label
                                    for="email-address"
                                    class="block text-sm font-medium text-iron-700"
                                    >Email address</label
                                >
                                <input
                                    id="email-address"
                                    v-model="form.email"
                                    type="text"
                                    name="email-address"
                                    autocomplete="email"
                                    class="mt-1 block w-full rounded-md border-iron-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                                />
                                <div
                                    v-if="form.errors.email"
                                    class="mt-2 text-xs text-error-600"
                                >
                                    {{ form.errors.email }}
                                </div>
                            </div>

                            <div class="col-span-6 sm:col-span-6">
                                <label
                                    for="password"
                                    class="block text-sm font-medium text-iron-700"
                                    >Password</label
                                >
                                <input
                                    id="password"
                                    v-model="form.password"
                                    type="password"
                                    name="password"
                                    autocomplete="password"
                                    class="mt-1 block w-full rounded-md border-iron-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                                />
                                <div
                                    v-if="form.errors.password"
                                    class="mt-2 text-xs text-error-600"
                                >
                                    {{ form.errors.password }}
                                </div>
                            </div>

                            <div class="col-span-6 sm:col-span-6">
                                <label
                                    for="password_confirmation"
                                    class="block text-sm font-medium text-iron-700"
                                    >Confirm Password</label
                                >
                                <input
                                    id="password_confirmation"
                                    v-model="form.password_confirmation"
                                    type="password"
                                    name="password_confirmation"
                                    autocomplete="password"
                                    class="mt-1 block w-full rounded-md border-iron-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                                />
                            </div>

                            <div class="col-span-6 sm:col-span-6">
                                <label
                                    for="country"
                                    class="block text-sm font-medium text-iron-700"
                                    >Country</label
                                >
                                <select
                                    id="country"
                                    v-model="form.country"
                                    class="mt-1 block w-full rounded-md border-iron-300 shadow-sm focus:border-z-orange-300 focus:ring focus:ring-z-orange-200 focus:ring-opacity-50"
                                    required
                                >
                                    <option :value="null">-</option>
                                    <option
                                        v-for="(
                                            country, countryCode
                                        ) in countries"
                                        :key="countryCode"
                                        :value="countryCode"
                                    >
                                        {{ country }}
                                    </option>
                                </select>
                                <div
                                    v-if="form.errors.country"
                                    class="mt-2 text-xs text-error-600"
                                >
                                    {{ form.errors.country }}
                                </div>
                            </div>
                        </div>

                        <div class="mt-10 flex justify-end">
                            <inertia-link
                                :href="route('app.kiosk.users.index')"
                                type="button"
                                class="rounded-md border border-iron-300 bg-white px-4 py-2 text-sm font-medium text-iron-700 shadow-sm hover:bg-iron-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                                >Cancel</inertia-link
                            >
                            <button
                                type="submit"
                                class="ml-3 inline-flex justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                                @click="createUser"
                            >
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="py-12">
            <div class="mx-auto max-w-7xl sm:px-6 lg:px-8">
                <div
                    class="overflow-hidden bg-white shadow-xl sm:rounded-lg"
                ></div>
            </div>
        </div>
    </app-layout>
</template>

<script setup>
import AppLayout from "../../../../Layouts/AppLayout.vue";
import axios from "axios";
import { onMounted, ref } from "vue";
import { useForm } from "@inertiajs/vue3";

const countries = ref([]);
const form = useForm({
    name: "",
    email: "",
    password: "",
    password_confirmation: "",
    country: null,
    terms: true,
});

const getCountries = async () => {
    axios.get(route("countries.index")).then((res) => {
        countries.value = res.data.data;
    });
};

const createUser = () => {
    form.post(route("app.kiosk.users.store"), {
        onFinish: () => form.reset("password", "password_confirmation"),
    });
};

onMounted(() => {
    getCountries();
});
</script>
